import React, { useState } from "react";
import useForm from './hooks/useForm';
import { FormField, LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from './hooks/useFetch';
import { useNavigate } from "react-router-dom";
import { getClientSubdomain } from './utils';
import {
  Page,
  MazeOverlay,
  Card,
  BrandLogo,
  Head,
  Title,
  Subtitle,
  FieldWrap,
  fieldLabelStyle,
  TextLink,
  ErrorSlot,
  SubmitRow,
  SubmitButton,
  SpinnerWrap,
  Foot,
  Tagline,
  CrossLink
} from './sharedComponents/AuthPageLayout';

export default () => {
  const navigate = useNavigate();

  const clientSubdomain = getClientSubdomain()

  const isStarSubdomain = (clientSubdomain === 'star')

  const fetch = useFetch();

  const [isBusy, setIsBusy] = useState(false);
  const [showInvalidLogin, setShowInvalidLogin] = useState(false);

  const formSchema = {
    requiredFields: ['email'],
    initData: {
      email: '',
    }
  }

  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    if (formData.isValid()) {
      setIsBusy(true)

      const response = await fetch(
        `auth/resetPasswordRequest`,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(formData.values)
        }
      )

      const jsonData = await response.json() || {};

      const { status = '' } = jsonData;

      if (status) {
        navigate('/')
      } else {
        setShowInvalidLogin(true)
      }

      setIsBusy(false)
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }

  return (
    <Page $isStar={isStarSubdomain}>

      { !isStarSubdomain && <MazeOverlay aria-hidden="true" /> }

      <Card>

        { !isStarSubdomain && <BrandLogo /> }

        <Head>
          <Title>{'Request Password Reset'}</Title>
          <Subtitle>{'Enter your email and we’ll send you a link to reset your password.'}</Subtitle>
        </Head>

        <FieldWrap $invalid={!!formData.missingValues['email']}>
          <FormField
            label='Email'
            labelStyle={fieldLabelStyle}
            fieldId='email'
            type='text'
            placeholder='you@district.org'
            formData={formData}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <ErrorSlot>
          { (!isBusy && showInvalidLogin) ? 'An error has occured' : '' }
        </ErrorSlot>

        <SubmitRow>
          <SubmitButton onClick={onClickSubmit}>
            {'Send Reset Link'}
          </SubmitButton>
          {
            isBusy &&
            <SpinnerWrap>
              <LoadingIcon />
            </SpinnerWrap>
          }
        </SubmitRow>

        <Foot>
          { !isStarSubdomain && <Tagline>{'The Human Skills Company'}</Tagline> }
          <CrossLink>
            <TextLink onClick={() => navigate('/')} style={{ fontSize: '14px' }}>
              {'Back to sign in'}
            </TextLink>
          </CrossLink>
        </Foot>

      </Card>
    </Page>
  )
}
